import {Link} from "react-router-dom";
import {Tooltip} from "antd";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import {useGetMySubscriptionQuery} from "~/reduxs/api/subscriptionApiSlice";
import style from "../style/AiTool.module.scss";

const cn = className.bind(style);

const nf = (n) => Number(n || 0).toLocaleString('vi-VN');

/**
 * Dòng "Còn ~N token" hiển thị ngay tại màn AI — khỏi phải nhìn sidebar/subscription.
 * Số liệu từ subscription/me; mutation AI invalidate 'Subscription' nên tự cập nhật
 * sau mỗi lượt tạo nội dung/chat. Root/khoá riêng → không trừ hạn mức, hiển thị tương ứng.
 */
function TokenRemaining() {

	const {data: sub} = useGetMySubscriptionQuery();

	if (!sub) return null;

	if (sub.is_root) return null;

	if (sub.require_own_ai_key) {
		return (
			<span className={cn('tokenBadge')}>
				<FontAwesomeIcon icon="fa-light fa-key" /> Dùng khoá AI riêng — không trừ hạn mức gói
			</span>
		);
	}

	const tk = sub.ai_tokens || {};
	const low = tk.limit > 0 && tk.remaining / tk.limit < 0.1;

	return (
		<Tooltip title={`Đã dùng ${nf(tk.used)} / ${nf(tk.limit)} token tháng này`}>
			<Link to="/subscription" className={cn('tokenBadge', {low})}>
				<FontAwesomeIcon icon="fa-light fa-wand-magic-sparkles" />
				Còn ~{nf(tk.remaining)} token AI tháng này
			</Link>
		</Tooltip>
	);
}

export default TokenRemaining;
